import GoogleMap from './components/google-map'
import GoogleMarker from './components/map-marker'
import InfoWindow from './components/info-window'
import Autocomplete from './components/autocomplete'
import Clusterer from './components/map-cluster'
import CustomGoogleOverlay from './utils/CustomGoogleOverlay'
import Vue from 'vue'
import bulmaCollapsible from '@creativebulma/bulma-collapsible';


export default {
  install(Vue, options) {
    Vue.prototype.$googleApiPromise = this._createGoogleApiPromise();
    let apiUrl = this._getGoogleApiUrl(options);
    this._embedScript(apiUrl, false, false);
    this._registerComponents();
    this._setCustomOverlayPrototype();
  },

  _getGoogleApiUrl(options) {
    let baseUrl = 'https://maps.googleapis.com/';
    let mapUri = 'maps/api/js?';

    options['callback'] = 'googleApiPromise';

    return baseUrl + mapUri + Object.keys(options)
      .map(key =>encodeURIComponent(key) + '=' + encodeURIComponent(options[key]))
      .join('&')
  },

  _embedScript(url, defer = true, async = true) {
    let scriptEl = document.createElement('script');

    scriptEl.setAttribute('src', url);
    scriptEl.setAttribute('async', async);
    scriptEl.setAttribute('defer', defer);

    document.head.appendChild(scriptEl);
  },

  _createGoogleApiPromise() {
    return new Promise((resolve, reject) => {
      window.googleApiPromise = () => {
        if(window.google) {
          resolve(window.google);
        }else {
          reject();
        }
      }
    });
  },

  _registerComponents() {
    Vue.component('google-map', GoogleMap)
    Vue.component('google-marker', GoogleMarker)
    Vue.component('info-window', InfoWindow)
    Vue.component('google-autocomplete', Autocomplete)
    Vue.component('google-cluster', Clusterer)
  },

  _setCustomOverlayPrototype() {
    Vue.prototype.$googleApiPromise.then(google => {
      CustomGoogleOverlay.prototype = new google.maps.OverlayView();
    })
  }
}
